import XcolumnFunc from "@/pcomponents/common/xcolumn/xcolumn/xcolumn_func";
//const xColumnArr=getXcolumnJson();

const getXcolumnJson = () => {
  let initData: any = {
    table: "mpoint",
    list_id: "mpoint_use_list",
    x_column_list_arr: [
      { "key": "a_date", "name": "거래일", "width": "110", "is_show": "1" },
      // {"key":"a_amount","name":"포인트","width":"100","is_show":"1"},
      // {"key":"a_sort","name":"구분1","width":"100","is_show":"1"},
      // {"key":"a_sort_detail","name":"구분","width":"100","is_show":"1"},
      { "key": "a_memo", "name": "적요", "width": "250", "is_show": "1" },
      { "key": "row_view_in_point", "name": "충전", "width": "100", "is_show": "1" },
      { "key": "row_view_out_point", "name": "사용", "width": "100", "is_show": "1" },
      { "key": "row_view_remain_point", "name": "잔액", "width": "100", "is_show": "1" },
      { "key": "a_writer", "name": "작성자", "width": "140", "is_show": "1" },
      {"key":"a_create_date","name":"작성일","width":"160","is_show":"1"},
    ],
    list_opt_origin: {
      'now_page': 1,
      'num_per_page': 30,
      'order_id':'a_date DESC, a_ymd DESC, a_seq DESC',
      'order_type': '',
      's_date_type': '',
      's_start_date': '',
      's_end_date': '',
      'sc': {},
      "is_add_idx_info":"1",
    },
    order_id_col_arr: [
      { "value": "", "text": "없음" },
    ]
  };
  initData.pri_col_arr = ["a_ymd", "a_seq"];
  const xColumnArr: any = XcolumnFunc.getDefaultXcolumn(initData);

  return xColumnArr;
};

export default getXcolumnJson;